import { useEffect, useState } from 'react';
import { api } from '../../api';
import { RESELLER_PERM_LIST, groupPerms, withImplications } from '../../resellerPerms';
import { useIsMobile } from '../../utils';

// #210 etapa 2 — «Techo de permisos» de una empresa reseller: lo máximo que cualquiera de sus
// usuarios puede tener. Se guarda aparte del resto del modal (es otro endpoint, sólo admin).
export function ResellerCeilingEditor({ clientId }) {
  const isMobile = useIsMobile();
  const [ceiling, setCeiling] = useState(null);
  const [saving, setSaving]   = useState(false);
  const [msg, setMsg]         = useState(null);   // { ok, text }

  useEffect(() => {
    let alive = true;
    api.getResellerCeiling(clientId)
      .then(c => { if (alive) setCeiling(c); })
      .catch(e => { if (alive) setMsg({ ok: false, text: e.message }); });
    return () => { alive = false; };
  }, [clientId]);

  const toggle = (k) => { setMsg(null); setCeiling(c => withImplications({ ...c, [k]: !c[k] })); };

  const save = async () => {
    setSaving(true); setMsg(null);
    try {
      setCeiling(await api.updateResellerCeiling(clientId, ceiling));
      setMsg({ ok: true, text: 'Techo guardado. Los usuarios que lo superaban quedaron recortados.' });
    } catch (e) { setMsg({ ok: false, text: e.message }); }
    finally { setSaving(false); }
  };

  return (
    <div style={{ marginTop: 18, paddingTop: 14, borderTop: '1px solid var(--border)' }}>
      <div style={{ fontSize: 10, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--muted)', marginBottom: 4, fontFamily: 'var(--mono)' }}>
        Techo de permisos
      </div>
      <div style={{ fontSize: 11, color: 'var(--muted)', fontFamily: 'var(--mono)', marginBottom: 10 }}>
        Lo máximo que pueden tener los usuarios de la empresa. Al bajarlo, a quien lo superaba se le recorta en el acto.
      </div>
      {ceiling && (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 6 }}>
            {Object.values(groupPerms(RESELLER_PERM_LIST)).flat().map(({ key, label }) => (
              <label key={key} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 10px', background: 'var(--bg)', border: '1px solid var(--border)', cursor: 'pointer', fontSize: 12 }}>
                <input type="checkbox" checked={!!ceiling[key]} onChange={() => toggle(key)}
                  style={{ accentColor: 'var(--yellow)' }} />
                {label}
              </label>
            ))}
          </div>
          <div style={{ marginTop: 10, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
            <button onClick={save} disabled={saving}
              style={{ background: 'transparent', border: '1px solid var(--yellow)', color: 'var(--yellow)', padding: '6px 12px', fontSize: 11, fontFamily: 'var(--mono)', cursor: saving ? 'not-allowed' : 'pointer' }}>
              {saving ? 'GUARDANDO...' : 'GUARDAR TECHO'}
            </button>
          </div>
        </>
      )}
      {msg && (
        <div style={{ marginTop: 8, fontSize: 12, fontFamily: 'var(--mono)', color: msg.ok ? 'var(--green, #4ade80)' : 'var(--red)' }}>{msg.text}</div>
      )}
    </div>
  );
}
